import { Form, Formik } from "formik"
import FormikInputField from "helpers/FormikInputField"
import { useLoading } from "helpers/custom_hooks"
import React, { useState } from "react"
import { Alert, Col, Row, TabPane } from "reactstrap"
import { displayMessage } from "helpers/misc_helpers"
import { CreateRepairRequest, ResetRepairRequest } from "helpers/backend_helper"

const RepairRequestDataTab = ({ nextTab, request, setRequest }) => {
  const fields = [
    {
      fieldName: "partNumber",
      label: "Manufacturer Part Number",
      component: FormikInputField,
    },

    {
      fieldName: "quantity",
      label: "Quantity",
      component: FormikInputField,
    },
    {
      fieldName: "internalOrderNumber",
      label: "Internal Order Number",
      component: FormikInputField,
    },
    {
      fieldName: "notes",
      label: "Notes",
      component: FormikInputField,
    },
    {
      fieldName: "dateCodes",
      label: "Datecodes",
      component: FormikInputField,
    },
  ]

  const setLoading = useLoading()
  const [error, setError] = useState()
  const initialValues = {
    ...request,
    notes: request?.notes ?? "",
    internalOrderNumber: request?.internalOrderNumber ?? "",
    quantity: request?.quantity ?? "",
    dateCodes: request?.dateCodes ?? "",
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true)
      if (values.id) await ResetRepairRequest(values)
      else {
        const result = await CreateRepairRequest(values)
        setRequest({ ...request, id: result?.id })
      }
      nextTab(1)
    } catch (error) {
      console.log(error)
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unhandled exception happened!", setError)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  return (
    <TabPane tabId={3}>
      <div className="row pt-4 px-5">
        <Col lg="6">
          <div className="">
            <div>
              {error && <Alert color="danger">{error}</Alert>}

              <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ errors, touched }) => (
                  <Form>
                    <Row>
                      {fields.map((field, key) => (
                        <Col lg="6" key={key}>
                          <field.component
                            fieldName={field.fieldName}
                            label={field.label}
                            errors={errors}
                            touched={touched}
                          />
                        </Col>
                      ))}
                    </Row>
                    <div className="mt-3">
                      <Alert color="info">
                        <i className="fas fa-info-circle me-2"></i>
                        If you want to add images or other information, please
                        do so in the chat on the request's detail page.
                      </Alert>
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Confirm
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Col>
      </div>
    </TabPane>
  )
}

export default RepairRequestDataTab
